import React from 'react';
import Slider from 'react-slick';
import 'slick-carousel/slick/slick.css';
import 'slick-carousel/slick/slick-theme.css';

const logos = [
  { src: '/assets/images/cl/cyber.png', alt: 'Logo 1', link:"/course-details/Cyber-Security" },
  { src: '/assets/images/cl/da.png', alt: 'Logo 2', link:"/course-details/Data-Analytics" },
  { src: '/assets/images/cl/ds.png', alt: 'Logo 3', link:"/course-details/Data-Science-And-Data-Analytics" },
  { src: '/assets/images/cl/devops.png', alt: 'Logo 4', link:"/course-details/Cloud-Computing" },
  { src: '/assets/images/cl/digital m.png', alt: 'Logo 5', link:"/course-details/Digital-Marketing" },
    { src: '/assets/images/cl/android.png', alt: 'Logo 11', link:"/course-details/Android-Development" },
    { src: '/assets/images/cl/dot net.png', alt: 'Logo 14', link:"/course-details/Full-Stack-Dot-Net-Development" },
    { src: '/assets/images/cl/java.png', alt: 'Logo 15', link:"/course-details/Full-Stack-Java-Development" },
    { src: '/assets/images/cl/mern.png', alt: 'Logo 16', link:"/course-details/MERN-Stack-Development" },
    { src: '/assets/images/cl/python.png', alt: 'Logo 18', link:"/course-details/Full-Stack-Python-Development" },
    { src: '/assets/images/cl/test.png', alt: 'Logo 19', link:"/course-details/Software-Testing" },
];

const CourseLogoSlider = () => {
  const middleIndex = Math.floor(logos.length / 2);

  const settings = {
  centerMode: true,
  centerPadding: '0',
  infinite: true,
  autoplay: true,
  speed: 800,
  slidesToShow: 5,
  slidesToScroll: 1,
  arrows: false,
  responsive: [
    {
      breakpoint: 768,
      settings: {
        slidesToShow: 3,  // show 3 logos on tablet/mobile
        centerMode: true,
        centerPadding: '0',
      },
    },
    {
      breakpoint: 480,
      settings: {
        slidesToShow: 3,  // also 3 logos on smaller mobiles
        centerMode: true,
        centerPadding: '0',
      },
    },
  ],
};


  return (
    <div className="course-logo-slider">
      <Slider {...settings}>
        {logos.map((logo, index) => (
            <div key={index} className="d-flex justify-content-center align-items-center myclass22">
                <a href={logo.link} target='_blank'>
                  <img
                  src={logo.src}
                  alt={logo.alt || `Logo ${index + 1}`}
                  className="logo-img"
                  />
                </a>
            </div>
            ))}
      </Slider>
    </div>
  );
};

export default CourseLogoSlider;
